import infoGreen from 'assets/images/account-page/info-green.svg';
import savesExportsIcon from 'assets/images/plan-saves-exports.svg';
import teamMemberIcon from 'assets/images/plan-team.svg';
import skipTracingIcon from 'assets/images/plan-skip-tracing.svg';
import classNames from "classnames";
import React, { useRef, useEffect } from "react";
import css from "../style.scss";
import numberFormat from 'utils/number/format';
import { getBrandName, isPropStream } from 'utils/brand';
import { useDispatch, useSelector } from 'react-redux';
import { selectPlanDetails, updateSelectedChooseTierTooltip } from '../../../../data/user';

import giftGreen from 'assets/images/plan-description/plan-gift.svg';
import planBatchdialer from 'assets/images/plan-description/plan-batchdialer.svg';
import accesskey from 'assets/images/plan-description/plan-access.svg';
import intelligenceIcon from 'assets/images/plan-description/plan-intelligence.svg';

const MonthlyEssentialsIncludes = ({ selectedPlanOption }) => {
    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();
    const intelligenceName = isPropStream() ? 'PropStream Intelligence' : 'Property Intelligence';
    const containerRef = useRef(null);

    const handleTooltipToggle = (tooltipId) => {
        const tooltipComponentId = `monthlyEssentials-${tooltipId}`;
        dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
    };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);

    return (
        <div className={css.clsInfoPopup} ref={containerRef}>
            <li>
                <img src={giftGreen} className={css.clsIncludesIcon} alt="7-Day Free Trial" />
                <p>
                    <strong>7-Day Free Trial</strong> With 50 Free Leads
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('trial')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-trial',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Free Trial <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Take a week and explore everything your <b>{getBrandName()}</b> plan has to offer.</p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={savesExportsIcon} className={css.clsIncludesIcon} alt="Monthly Saves & Exports" />
                <p>
                    <strong>{numberFormat(selectedPlanOption)} </strong>
                    Monthly Saves & Exports
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('saves')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-saves',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Saves & Exports <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}><b>{getBrandName()}</b> makes it easy to save, export, and organize your real estate leads for effective marketing and outreach. Quickly export your leads to use with other tools and keep your records up to date. Additional saves and exports are available for purchase.</p>
                            <p className={css.clsInfoContentPara}><b><i>NOTE: Unused saves and exports don't roll over. Each month your account resets to your regular limit.</i></b></p>
                        </div>
                    </span>
                </p>
            </li>
            <li>
                <img src={accesskey} className={css.clsIncludesIcon} alt="Access to Web & Mobile Platforms" />
                <p>Access to Web & Mobile Platforms</p>
            </li>
            <li>
                <img src={teamMemberIcon} className={css.clsIncludesIcon} alt="Additional Team Members Available" />
                <p>
                    Additional Team Members Available
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('team')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-team',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>Team Members <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Our Essentials plan is perfect for solo entrepreneurs. As your team grows, upgrade to Pro (2 team members) or Elite (up to 9 team members). Collaborate seamlessly and reach your goals faster!</p>
                        </div>
                    </span>
                </p>
            </li>
            {isPropStream() && (
                <li>
                    <img src={planBatchdialer} className={css.clsIncludesIcon} alt="BatchDialer" />
                    <p>
                        <strong>BatchDialer</strong> (Lifetime 20% off In-app)
                        <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('batchdialer')}>
                            <img src={infoGreen} alt="info" />
                            <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                                [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-batchdialer',
                            })}>
                                <h6 className={css.clsInfoContentTitle}>BatchDialer <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                                <p className={css.clsInfoContentPara}>Unlock 20% off after you start your {getBrandName()} trial using the in-app promotion.</p>
                            </div>
                        </span>
                    </p>
                </li>
            )}
            <li>
                <img src={intelligenceIcon} className={css.clsIncludesIcon} alt={intelligenceName} />
                <p>
                    <strong>{intelligenceName} Assistant</strong> Included
                    <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('intelligence')}>
                        <img src={infoGreen} alt="info" />
                        <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupLeft, {
                            [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === 'monthlyEssentials-intelligence',
                        })}>
                            <h6 className={css.clsInfoContentTitle}>{intelligenceName}<span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                            <p className={css.clsInfoContentPara}>Ask questions, get instant property insights, and analyze deals with the {intelligenceName} Assistant.</p>
                        </div>
                    </span>
                </p>
            </li>
        </div>
    );
};

export default MonthlyEssentialsIncludes;
